export default __webpack_public_path__ + "static/media/ManropeLight.96ff2cc2.woff";